import { useSelector } from 'react-redux';
import { logError } from 'hx-analytics/src/functions/logging/log-error.helper';
export function useTestCompletionCallback() {
    var _a = useSelector(function (state) { return state; }), dinTest = _a.dinTest, wizard = _a.wizard;
    function handleTestCompletion() {
        var _a, _b, _c;
        var referenceNumber = (_a = wizard.form) === null || _a === void 0 ? void 0 : _a['reference-number'];
        var birthYear = (_b = wizard.form) === null || _b === void 0 ? void 0 : _b['birth-year'];
        if (!isString(referenceNumber) || !isNumber(birthYear)) {
            logError({
                error: 'Missing/invalid reference number or birth year',
                message: 'Failed to trigger test complete postMessage',
                tag: {
                    name: 'test-complete',
                    value: 'missing data',
                },
                metadata: { dinTest: dinTest, wizard: wizard },
                level: 'error',
            });
            return;
        }
        if (!dinTest.result.category) {
            logError({
                error: 'Missing hearing category',
                message: 'Failed to trigger test complete postMessage',
                tag: {
                    name: 'test-complete',
                    value: 'missing data',
                },
                metadata: { dinTest: dinTest, wizard: wizard },
                level: 'error',
            });
            return;
        }
        var testData = {
            signal_to_noise_ratio: dinTest.result.averageSnr,
            result_category: dinTest.result.category,
            reference_number: referenceNumber,
            birth_year: birthYear,
            date: new Date().toJSON(),
        };
        (_c = window.parent) === null || _c === void 0 ? void 0 : _c.postMessage({ type: 'host/test-complete', payload: testData }, '*');
    }
    return handleTestCompletion;
}
function isString(value) {
    return typeof value === 'string';
}
function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
